import React from "react";
import Navbar from "../../components/navbar/Navbar";
import ViewOrder from "../../components/orders/ViewOrder";

const ViewOrderPage = () => {
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          {/* Navbar */}
          <div className="row">
            <div className="col-12 p-0">
              <Navbar content="VIEW ORDER" />
            </div>
          </div>
          <div className="row">
            <div className="col-12 p-0">
              <ViewOrder />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewOrderPage;
